import types from '../types';

/**
 * @param {types.CheckBoxOrRadioOption[]} subOptions
 * @returns {types.CheckBoxOrRadioOption[]}
 */
const getResetedCheckboxGroupSubOptionsState = subOptions => {
    if (!subOptions || !Array.isArray(subOptions) || !subOptions.length) {
        throw new Error('Options are missing!');
    }

    return subOptions.map(subOption => {return {
        ...subOption,
        checked: false
    }});
};

export default getResetedCheckboxGroupSubOptionsState;
